// extracted by mini-css-extract-plugin
export var common = "wrapper-module--common--aTCjk";
export var normal = "wrapper-module--normal--dnS73 wrapper-module--common--aTCjk";
export var post = "wrapper-module--post--cNLVK wrapper-module--common--aTCjk";